import { render, staticRenderFns } from "./rsv-msgs.vue?vue&type=template&id=6a3ef1ab&scoped=true&lang=pug&"
import script from "./rsv-msgs.vue?vue&type=script&lang=js&"
export * from "./rsv-msgs.vue?vue&type=script&lang=js&"
import style0 from "./rsv-msgs.vue?vue&type=style&index=0&id=6a3ef1ab&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3ef1ab",
  null
  
)

export default component.exports